import { Text } from '@backend/lib-design-system';
import { ArrowNextFilledIcon } from '@backend/lib-design-system/icons';
import { styled } from 'styled-components';

import { Link } from '~/components/Link';
import { useGetDomainPublicUrl, useTranslation } from '~/hooks';
import { getMediaQuery } from '~/utils/responsive/media';

const StyledButtonB2B = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: ${({ theme }) => theme.colors.warning.normal};
  color: #272356;
  border-radius: 38px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  transition:
    background-color 0.2s,
    color 0.2s;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.palette.white};
  }

  ${getMediaQuery('mobile')} {
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
  }
`;

const ButtonB2BText = styled(Text)`
  color: #272356 !important;
`;

const ButtonB2BTextMobile = styled(ButtonB2BText)`
  ${getMediaQuery('tablet', 'desktop', 'laptop')} {
    display: none;
  }
`;
const ButtonB2BTextDesktop = styled(ButtonB2BText)`
  ${getMediaQuery('mobile')} {
    display: none;
  }
`;

export const ButtonB2B = () => {
  const t = useTranslation();
  const getPublicUrl = useGetDomainPublicUrl();

  return (
    <StyledButtonB2B href={getPublicUrl('companySpace')} target="_blank" rel="noopener noreferrer">
      <ButtonB2BTextMobile variant="body" as="span">
        {t('menu.entreprise_button_mobile')}
      </ButtonB2BTextMobile>
      <ButtonB2BTextDesktop variant="body" as="span">
        {t('menu.b2b_button')}
      </ButtonB2BTextDesktop>
      <ArrowNextFilledIcon size="s" />
    </StyledButtonB2B>
  );
};
